/**
 * @generated SignedSource<<aab3b71bd57c423bb8d6405dfe3f65fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getPdpEstimateSimilarSold_viewer$data = {
  readonly similarSoldItemsResults?: {
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentType": "getPdpEstimateSimilarSold_viewer";
};
export type getPdpEstimateSimilarSold_viewer$key = {
  readonly " $data"?: getPdpEstimateSimilarSold_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"getPdpEstimateSimilarSold_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getPdpEstimateSimilarSold_viewer"
};

(node as any).hash = "8d342a26ad877cd8d49b14713216630e";

export default node;
